
import { getRenewal, renewalResponse, rnw02p, hsm03p } from "@/api/renewal";
import router from "@/router";
import { useStore } from "@/store";
import axios from "axios";
import { commaSplit } from "common/src/utils/number";
import { getGenderText, getHaraikomiText } from "common/src/utils/codes";
import HyphenParagraph from "common/src/components/HyphenParagraph.vue";
import SubInsured from "common/src/components/SubInsured.vue";
import constants from "common/src/constants";
import { defineComponent, reactive, ref, Ref, UnwrapRef } from "vue";
import { getSyoyuText, getYoutoText, getKozoText } from "common/src/utils/codes";

export default defineComponent({
  components: {
    HyphenParagraph,
    SubInsured,
  },
  setup() {
    const store = useStore();

    const renewal: UnwrapRef<renewalResponse> = reactive({
      rnw01p: undefined,
      hsm03p: undefined,
      rnw02p: undefined,
    });
    const mainInsured: Ref<rnw02p | undefined> = ref(undefined);
    const subInsureds: Ref<rnw02p[] | undefined> = ref(undefined);
    // 他保険種類管理配列
    const thRethsrArr: Ref<string[]> = ref([]);

    const selectedPlan: Ref<hsm03p | undefined> = ref(undefined);
    const nowDate = `${new Date().getFullYear()}/${`00${new Date().getMonth() + 1}`.slice(-2)}/${`00${new Date().getDate()}`.slice(-2)}`;

    getRenewal()
      .then((res) => {
        if (res.data.rnw01p?.tf_rekzis === constants.KEIZOKU_ISHI.ARI) {
          router.push({ name: "404" });
          return;
        }

        renewal.rnw01p = res.data.rnw01p;
        renewal.hsm03p = res.data.hsm03p;
        renewal.rnw02p = res.data.rnw02p;

        mainInsured.value = res.data.rnw02p?.find((i) => i.tf_rhhkno === constants.MAIN_INSURED_NUMBER);
        subInsureds.value = res.data.rnw02p
          ?.filter((i) => i.tf_rhhkno !== constants.MAIN_INSURED_NUMBER)
          .sort((a, b) => Number.parseInt(a.tf_rhhkno) - Number.parseInt(b.tf_rhhkno));

        // 更新契約手続きAPI呼び出し用Formの値をセット
        if (renewal.rnw01p !== undefined) {
          renewal.rnw01p.tf_rekytl = store.state.renewal?.rnw01p.tfRekytl ?? "";
          renewal.rnw01p.tf_rekyt2 = store.state.renewal?.rnw01p.tfRekyt2 ?? "";
          renewal.rnw01p.tf_rehscd = store.state.renewal?.rnw01p.tfRehscd ?? "";
          renewal.rnw01p.tf_rehkpl = store.state.renewal?.rnw01p.tfRehkpl ?? "";
          renewal.rnw01p.tf_regkhk = store.state.renewal?.rnw01p.tfRegkhk ?? 0;
          renewal.rnw01p.tf_rehkhh = store.state.renewal?.rnw01p.tfRehkhh ?? "";
          renewal.rnw01p.tf_rethum = store.state.renewal?.rnw01p.tfRethum ?? "";
          renewal.rnw01p.tf_rethcm = store.state.renewal?.rnw01p.tfRethcm ?? "";
          thRethsrArr.value.push(...(store.state.renewal?.rnw01p.tfRethsr?.split("/") ?? ""));
          if (store.state.renewal?.security.tfHnuuid && store.state.mail) {
            renewal.rnw01p.tf_rekyma = store.state.mail;
          }
          selectedPlan.value = res.data.hsm03p?.find((i) => i.tf_hrplan === store.state.renewal?.rnw01p.tfRehkpl);
        }
        if (mainInsured?.value !== undefined) {
          mainInsured.value.tf_rhhktl = store.state.renewal?.rnw02p.tfRhhktl ?? "";
          mainInsured.value.tf_rhhkt2 = store.state.renewal?.rnw02p.tfRhhkt2 ?? "";
        }
      })
      .catch((err) => {
        if (axios.isAxiosError(err) && err.response?.status === 404) {
          router.push({ name: "404" });
        }
      });

    return {
      renewal,
      mainInsured,
      subInsureds,
      thRethsrArr,
      selectedPlan,
      nowDate,
      getGenderText,
      getHaraikomiText,
      commaSplit,
      constants,
      getSyoyuText,
      getYoutoText,
      getKozoText,
    };
  },
});
